/** Shared block type ids and defaults for PageBuilder + import + PageRenderer */

export const BLOCK_TYPES = {
  TEXT: "text",
  IMAGE: "image",
  HEADER: "header",
  SECTION: "section",
  BUTTON: "button",
  COLUMNS: "columns",
};

export const DEFAULT_BLOCKS = {
  [BLOCK_TYPES.TEXT]: {
    type: BLOCK_TYPES.TEXT,
    content: "<p>Dette er en tekstblokk. Klikk for å redigere.</p>",
    styles: {
      fontSize: "16px",
      color: "#000000",
      textAlign: "left",
      padding: "16px",
      fontFamily: "inherit",
      fontWeight: "normal",
    },
  },
  [BLOCK_TYPES.IMAGE]: {
    type: BLOCK_TYPES.IMAGE,
    src: "",
    alt: "",
    title: "",
    documentId: null,
    styles: {
      width: "100%",
      maxWidth: "100%",
      padding: "16px",
    },
  },
  [BLOCK_TYPES.HEADER]: {
    type: BLOCK_TYPES.HEADER,
    level: 1,
    content: "Overskrift",
    styles: {
      fontSize: "32px",
      fontWeight: "bold",
      color: "#000000",
      padding: "16px",
      fontFamily: "inherit",
    },
  },
  [BLOCK_TYPES.SECTION]: {
    type: BLOCK_TYPES.SECTION,
    backgroundColor: "#ffffff",
    padding: "32px",
    children: [],
  },
  [BLOCK_TYPES.BUTTON]: {
    type: BLOCK_TYPES.BUTTON,
    text: "Klikk her",
    link: "",
    styles: {
      backgroundColor: "#3B82F6",
      color: "#ffffff",
      padding: "12px 24px",
      borderRadius: "4px",
      border: "none",
      cursor: "pointer",
      fontSize: "16px",
    },
  },
  [BLOCK_TYPES.COLUMNS]: {
    type: BLOCK_TYPES.COLUMNS,
    columns: 2,
    gap: "16px",
    children: [[], []],
  },
};

export function newPageBuilderBlockId() {
  return `block-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
